import { useEffect, useState } from "react";
import {
  ANALYTICS_CONSENT_CHANGED_EVENT,
  ANALYTICS_CONSENT_SETTINGS_EVENT,
  analyticsAvailable,
  ensureAnalyticsLoaded,
  getAnalyticsConsent,
  resetAnalyticsConsent,
  setAnalyticsConsent,
  shouldShowAnalyticsConsentPrompt
} from "../analytics";
import { isShowMode } from "../showMode";

export default function AnalyticsConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isShowMode || !analyticsAvailable()) return;

    const refresh = () => {
      const consent = getAnalyticsConsent();
      const shouldPrompt = shouldShowAnalyticsConsentPrompt(consent);
      setVisible(shouldPrompt);
      if (!shouldPrompt && consent?.decision === "accepted") {
        ensureAnalyticsLoaded();
      }
    };
    const openSettings = () => {
      resetAnalyticsConsent();
      setVisible(true);
    };

    refresh();
    window.addEventListener(ANALYTICS_CONSENT_CHANGED_EVENT, refresh);
    window.addEventListener(ANALYTICS_CONSENT_SETTINGS_EVENT, openSettings);
    return () => {
      window.removeEventListener(ANALYTICS_CONSENT_CHANGED_EVENT, refresh);
      window.removeEventListener(ANALYTICS_CONSENT_SETTINGS_EVENT, openSettings);
    };
  }, []);

  if (!isShowMode || !analyticsAvailable() || !visible) return null;

  return (
    <div className="analytics-consent" role="dialog" aria-modal="true" aria-labelledby="analytics-consent-title">
      <div className="analytics-consent-panel">
        <div className="analytics-consent-copy">
          <strong id="analytics-consent-title">Privacy settings</strong>
          <p>
            We can collect privacy-friendly usage statistics with self-hosted Umami after your consent.
            No marketing cookies are used, and no filter values, search text, IDs, or personal entries are
            sent as analytics event data.
          </p>
        </div>
        <div className="analytics-consent-actions">
          <button
            type="button"
            className="button secondary"
            onClick={() => setAnalyticsConsent("rejected")}
          >
            Reject analytics
          </button>
          <button type="button" className="button" onClick={() => setAnalyticsConsent("accepted")}>
            Accept analytics
          </button>
        </div>
      </div>
    </div>
  );
}
